import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

const ThankyouOrderPlace = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    // ✅ Clear only cart/order data, NOT authentication tokens
    dispatch({ type: "CLEAR_CART" });
    dispatch({ type: "CLEAR_PACKAGES" });
    dispatch({ type: "CLEAR_PERSONALISED" });

    // Clear only order-specific data from localStorage
    localStorage.removeItem("easypostShipping");
    localStorage.removeItem("selectedShipping");
    localStorage.removeItem("customerId");
    localStorage.removeItem("services");
    localStorage.removeItem("subservices");
    localStorage.removeItem("innerdress");

    // ❌ DON'T clear 'user' or 'token' - keep user logged in!

    // Redirect after 5 seconds
    const timer = setTimeout(() => {
      navigate("/");
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate, dispatch]);

  return (
    <div className="thankyouSec">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="thankyouContent">
              <h1>Thank you</h1>
              <p>Thank you! Your order has been successfully placed.</p>
              <p style={{ marginTop: "20px", fontSize: "14px", color: "#666" }}>
                Redirecting to homepage in 5 seconds...
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankyouOrderPlace;
